// for progress bar js code start here

function getCartDiscountOffer() {
  const hasNFLItem = document.querySelector('.items_card.nfl_product');
  const hasNotNFLItem = document.querySelector('.items_card.notnfl_product');

  // If ANY non-NFL product exists → use original offer
  if (hasNotNFLItem) {
    return {
      code: window.shopifySettings?.offerCode,
      percentage: window.shopifySettings?.percentagediscount,
      isNFL: false
    };
  }

  // If only NFL products exist → use collection offer
  if (hasNFLItem) {
    return {
      code: window.collectionDiscountSettings?.code,
      percentage: window.collectionDiscountSettings?.percentage,
      isNFL: true
    };
  }

  // Default fallback
  return {
    code: window.shopifySettings?.offerCode,
    percentage: window.shopifySettings?.percentagediscount,
    isNFL: false
  };
}




function getCartProgressWidths(cart_value) {
 const freeshippingvalue = Number(window.shopifySettings?.freeShippingValue || 99);
 const offer_min_amount = Number(window.shopifySettings?.offerMinValue );
 const range_offer = offer_min_amount - freeshippingvalue;
 const shippingWidth = Math.min((cart_value / freeshippingvalue) * 100, 100);
 let offerWidth = 0;
 if (cart_value > freeshippingvalue) {
   offerWidth = Math.min(
     ((cart_value - freeshippingvalue) / range_offer) * 100,
     100
   );
 }
 return {
   shippingWidth,
   offerWidth,
   freeshippingvalue
 };
}
function applySavedProgressState() {
 const progressFill = document.querySelector('.freeshippingbar .segment-fill');
 const offerprogress = document.querySelector('.progress-segment .offer_sagment');
 const freeshippingicon = document.querySelector('.freeshippingbar .frrshippingicon');
 const offerIcon = document.querySelector('.offericonhit');
 const discount_percent=(window.shopifySettings?.percentagediscount || 20);
 const freeshipping_txt=(window.shopifySettings?.freeshippingtext );
 const first_coupon_txt=(window.shopifySettings?.firstcouponcode );
 const unlock_txt=(window.shopifySettings?.unlocktext );




 const savedShippingWidth = sessionStorage.getItem('shippingProgressWidth') || 0;
 const savedOfferWidth = sessionStorage.getItem('offerProgressWidth') || 0;
 const savedFreeShippingHit = sessionStorage.getItem('freeShippingHit') === 'true';
 const savedOfferHit = sessionStorage.getItem('offerIconHit') === 'true';




 if (progressFill) {
   progressFill.style.transition = 'none';
   progressFill.style.width = `${savedShippingWidth}%`;
 }




 if (offerprogress) {
   offerprogress.style.transition = 'none';
   offerprogress.style.width = `${savedOfferWidth}%`;
 }




 if (freeshippingicon) {
   freeshippingicon.classList.toggle('freeshippinghit', savedFreeShippingHit);
 }




 if (offerIcon) {
   offerIcon.classList.toggle('offer_icon_color', savedOfferHit);
 }


 // Restore free-shipping text synchronously to prevent the flash caused by
 // Liquid-default text appearing between a section re-render and the next
 // async updateFreeShippingBar() fetch completing.
 const savedCV = parseFloat(sessionStorage.getItem('cartValueForShipping') || '0');
 const textOffer = document.querySelector('.free_shipping_text');
 if (savedCV > 0 && textOffer) {
  const freeshippingvalue = Number(window.shopifySettings?.freeShippingValue || 99);
  const offer_min_amount = Number(window.shopifySettings?.offerMinValue || 150);
   const currentCV = parseFloat(textOffer.dataset.cartValue || '-1');
   if (currentCV !== savedCV) {
     // Write the version stamp first so MO callbacks triggered by innerHTML
     // see currentCV === savedCV and skip — preventing an infinite loop.
     textOffer.dataset.cartValue = savedCV;
     if (savedCV < freeshippingvalue) {
       const remaining = (freeshippingvalue - savedCV).toFixed(2);
       textOffer.innerHTML = `Add <span class="remaingbalance">$${remaining}</span> for <span class="highlited_text_cart_drawer">${freeshipping_txt}</span>`;
     } else if (savedCV < offer_min_amount) {
       const remaining = (offer_min_amount - savedCV).toFixed(2);
       textOffer.innerHTML = `<span class="first_coupon_text">✅ <span class="hightlighted_unlock">${first_coupon_code}</span> ${unlock_txt}</span> You're <span class="remaingbalance">$${remaining}</span> away from <span class="offer-highlight">${discount_percent}% OFF</span>`;
     } else {
  const savedOfferData = getCartDiscountOffer();

  const savedOfferPercent =
    savedOfferData.percentage ||
    window.shopifySettings?.percentagediscount ||
    20;

  textOffer.classList.toggle(
    'yessss',
    savedOfferData.isNFL
  );

  textOffer.innerHTML = `
    Use Code:
    <span style="color:#ff3366;font-weight:700;">
      ${savedOfferData.code}
    </span>
    for
    <span style="color:#f4a261;font-weight:700;">
      ${savedOfferPercent}% OFF
    </span>
  `;
}
   }
 }
}
function updateFreeShippingBar() {
 applySavedProgressState();
 fetch('/cart.js')
   .then(res => res.json())
   .then(cart => {
  const currentOffer = getCartDiscountOffer();

const collection_discount_percent =
  currentOffer.percentage ||
  window.shopifySettings?.percentagediscount ||
  20;
     const cart_value = (cart.original_total_price || cart.items_subtotal_price) / 100;
const freeshippingvalue = Number(window.shopifySettings?.freeShippingValue || 99);
const offer_min_amount = Number(window.shopifySettings?.offerMinValue || 150);
const discount_percent=(window.shopifySettings?.percentagediscount || 20);
const freeshipping_txt=(window.shopifySettings?.freeshippingtext );
 const first_coupon_txt=(window.shopifySettings?.firstcouponcode );
 const unlock_txt=(window.shopifySettings?.unlocktext );
     sessionStorage.setItem('cartValueForShipping', cart_value);
     const progressFill = document.querySelector('.freeshippingbar .segment-fill');
     const offerprogress = document.querySelector('.progress-segment .offer_sagment');
     const freeshippingicon = document.querySelector('.freeshippingbar .frrshippingicon');
     const offerIcon = document.querySelector('.offericonhit');
const text_offer=document.querySelector(".free_shipping_text");
const dynamic_price_text=document.querySelector(".dynamic_price_txt");
// let freeshippingvalue=99;
if (cart_value < freeshippingvalue) {
 const remainingAmount = (freeshippingvalue - cart_value).toFixed(2);
 text_offer.innerHTML =
   `Add <span class="remaingbalance">$${remainingAmount}</span> for <span class="highlited_text_cart_drawer">${freeshipping_txt}</span>`;
} else if (cart_value < offer_min_amount) {
 const remainingOfferAmount = (offer_min_amount - cart_value).toFixed(2);
 text_offer.innerHTML = `
  <span class="hightlighted_unlock">${first_coupon_txt}</span> ${unlock_txt} You're <span class="remaingbalance">$${remainingOfferAmount}</span>
 away from <span class="offer-highlight">${discount_percent}% OFF</span>
`;
} else {
  const activeOfferData = getCartDiscountOffer();

  const activeOfferPercent =
    activeOfferData.percentage ||
    window.shopifySettings?.percentagediscount ||
    20;

  text_offer.classList.toggle(
    'yessss',
    activeOfferData.isNFL
  );

  text_offer.innerHTML = `
    Use Code:
    <span style="color:#ff3366;font-weight:700;">
      ${activeOfferData.code}
    </span>
    for
    <span style="color:#f4a261;font-weight:700;">
      ${activeOfferPercent}% OFF
    </span>
  `;
}
      if (!progressFill || !offerprogress) return;
   const {
 shippingWidth,
 offerWidth
} = getCartProgressWidths(cart_value);
     const freeShippingHit = cart_value >= freeshippingvalue;
     const offerHit = offerWidth >= 100;
     progressFill.offsetHeight;
     offerprogress.offsetHeight;
     progressFill.style.transition = 'width 0.4s ease';
     offerprogress.style.transition = 'width 0.4s ease';
     requestAnimationFrame(() => {
       progressFill.style.width = `${shippingWidth}%`;
       offerprogress.style.width = `${offerWidth}%`;
     });
     if (freeshippingicon) {
       freeshippingicon.classList.toggle('freeshippinghit', freeShippingHit);
     }
     if (offerIcon) {
       offerIcon.classList.toggle('offer_icon_color', offerHit);
     }
     sessionStorage.setItem('shippingProgressWidth', shippingWidth);
     sessionStorage.setItem('offerProgressWidth', offerWidth);
     sessionStorage.setItem('freeShippingHit', freeShippingHit);
     sessionStorage.setItem('offerIconHit', offerHit);
   });
}
document.addEventListener('DOMContentLoaded', function () {
 applySavedProgressState();
 updateFreeShippingBar();
});
const originalFetch = window.fetch;
window.fetch = async (...args) => {
 const response = await originalFetch(...args);
 const url = args[0];
 if (
   typeof url === 'string' &&
   (
     url.includes('/cart/add') ||
     url.includes('/cart/change') ||
     url.includes('/cart/update') ||
     url.includes('/cart/clear')
   )
 ) {
   applySavedProgressState();
// alert("yess")
   requestAnimationFrame(() => {
     updateFreeShippingBar();
   });
 }
 return response;
};
// This fixes icon jerk after cart drawer re-render
const cartObserver = new MutationObserver(() => {
 applySavedProgressState();
});
cartObserver.observe(document.body, {
 childList: true,
 subtree: true
});


// end here progress bar code

function showDiscountRow() {
  const discountRow = document.querySelector('#discount-row');

  if (discountRow) {
    discountRow.classList.add('ld-discount-active');
    discountRow.style.display = 'flex';
  }
}

function formatMoney(cents) {
  return `$${(cents / 100).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`;
}

let activeDiscountCode = localStorage.getItem('activeDiscountCode') || '';
let cartUpdateTimer = null;
let isRemovingCoupon = false;

async function getCart() {
  return fetch('/cart.js', {
    credentials: 'same-origin',
    cache: 'no-store'
  }).then(res => res.json());
}

function getCalculatedDiscount(cart) {
  const originalTotal =
    cart.original_total_price ||
    cart.items_subtotal_price ||
    cart.total_price;

  return Math.max(0, originalTotal - cart.total_price);
}

function saveDiscountCode(code) {
  activeDiscountCode = code || '';

  if (code) {
    localStorage.setItem('activeDiscountCode', code);
  }
}

function clearSavedDiscountCode() {
  activeDiscountCode = '';
  localStorage.removeItem('activeDiscountCode');
}

function showCouponBadge(text) {
  const couponBadge = document.querySelector('.coupan_container_btn');
  const couponText = document.querySelector('#manual-coupon-result');

  if (couponBadge) couponBadge.style.display = 'flex';
  if (couponText) couponText.textContent = text || '';
}

function hideOnlyCouponBadge(force = false) {
  const couponBadge = document.querySelector('.coupan_container_btn');
  const couponText = document.querySelector('#manual-coupon-result');
  const savedCode = localStorage.getItem('activeDiscountCode');

  if (!force && savedCode) return;

  if (couponBadge) couponBadge.style.display = 'none';
  if (couponText) couponText.textContent = '';
}

function resetDiscountUI() {
  const discountEl = document.querySelector('#selected-discount');

  showDiscountRow();
  hideOnlyCouponBadge(true);

  if (discountEl) discountEl.textContent = '$0.00';
}

async function applyDiscountCode(code, shouldRefresh = true) {
  if (!code) return;

  await fetch('/discount/' + encodeURIComponent(code), {
    method: 'GET',
    credentials: 'same-origin',
    cache: 'no-store'
  });

  if (shouldRefresh) {
    await refreshCartUI(code, true);
  }
}

async function removeDiscountCode() {
  isRemovingCoupon = true;
  clearSavedDiscountCode();
  clearTimeout(cartUpdateTimer);
  resetDiscountUI();

  const checkoutBtn = document.querySelector('#custom-checkout-btn');

  if (checkoutBtn && checkoutBtn.tagName === 'A') {
    checkoutBtn.setAttribute('href', '/checkout');
  }

  document.querySelectorAll('input[name="discount"]').forEach(input => {
    input.value = '';
    input.remove();
  });

  try {
    await fetch('/discount/clear', {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store'
    });

    await fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ discount: '' })
    });

    await refreshCartUI();

    setTimeout(() => {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-discount-remove'
        });
      }

      isRemovingCoupon = false;
    }, 300);

  } catch (error) {
    console.error(error);
    isRemovingCoupon = false;
  }
}

async function refreshCartUI(lastEnteredCode = '', isManualApply = false) {
  const cart = await getCart();

  if (typeof updateFreeShippingProgress === 'function') {
    updateFreeShippingProgress(cart);
  }

  const savedCode = localStorage.getItem('activeDiscountCode') || activeDiscountCode;

  const discountEl = document.querySelector('#selected-discount');
  const finalTotalEl = document.querySelector('#estimated-total-final');
  const checkoutPriceEl = document.querySelector('#custom-checkout-btn span:last-child');

  if (finalTotalEl) {
    finalTotalEl.textContent = formatMoney(cart.total_price);
  }

  if (checkoutPriceEl) {
    checkoutPriceEl.textContent = formatMoney(cart.total_price);
  }

  const calculatedDiscount = getCalculatedDiscount(cart);

  showDiscountRow();

  if (calculatedDiscount > 0 && !isRemovingCoupon) {
    const validCode =
      cart.cart_level_discount_applications?.[0]?.title ||
      cart.discount_codes?.[0]?.code ||
      lastEnteredCode ||
      savedCode;

    if (discountEl) discountEl.textContent = formatMoney(calculatedDiscount);

    showCouponBadge(validCode);
    saveDiscountCode(validCode);

    return;
  }

  // Wrong coupon / minimum not matched / expired coupon
  if (isManualApply && calculatedDiscount <= 0 && !isRemovingCoupon) {
    clearSavedDiscountCode();
    resetDiscountUI();
    return;
  }

  // Cart update case: keep existing badge while Shopify recalculates
  if (savedCode && !isRemovingCoupon) {
    showCouponBadge(savedCode);

    setTimeout(async () => {
      await applyDiscountCode(savedCode, false);

      const latestCart = await getCart();
      const latestDiscount = getCalculatedDiscount(latestCart);

      if (latestDiscount > 0) {
        if (discountEl) discountEl.textContent = formatMoney(latestDiscount);
        showCouponBadge(savedCode);
      } else {
        clearSavedDiscountCode();
        resetDiscountUI();
      }
    }, 400);

    return;
  }

  if (!savedCode && !isRemovingCoupon) {
    resetDiscountUI();
  }
}

document.addEventListener('click', async function (e) {
  const applyBtn = e.target.closest('#apply-manual');

  if (!applyBtn) return;

  e.preventDefault();
  e.stopPropagation();

  const input = document.querySelector('#manual-code');
  const code = input?.value.trim();

  if (!code) {
    resetDiscountUI();
    return;
  }

  try {
    showCouponBadge('Applying...');

    await applyDiscountCode(code, true);

    if (input) input.value = '';

  } catch (error) {
    console.error(error);
    clearSavedDiscountCode();
    resetDiscountUI();
  }
}, true);

document.addEventListener('keydown', function (e) {
  const input = e.target.closest('#manual-code');

  if (!input || e.key !== 'Enter') return;

  e.preventDefault();
  e.stopPropagation();

  const applyBtn = document.querySelector('#apply-manual');

  if (applyBtn) {
    applyBtn.click();
  }
}, true);

document.addEventListener('click', async function (e) {
  const closeBtn = e.target.closest('.close-btn-coupon');

  if (!closeBtn) return;

  e.preventDefault();
  e.stopPropagation();

  await removeDiscountCode();
}, true);

function scheduleCartUpdate(delay = 300) {
  clearTimeout(cartUpdateTimer);

  cartUpdateTimer = setTimeout(async () => {
    await refreshCartUI();
  }, delay);
}

document.addEventListener('DOMContentLoaded', refreshCartUI);

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
    if (data.source !== 'cart-discount-remove') {
      scheduleCartUpdate(350);
    }
  });
}

(function () {
  const originalFetch = window.fetch;

  window.fetch = async function () {
    const response = await originalFetch.apply(this, arguments);

    const url = typeof arguments[0] === 'string'
      ? arguments[0]
      : arguments[0]?.url;

    if (
      url &&
      (
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/clear')
      )
    ) {
      scheduleCartUpdate(300);
    }

    return response;
  };
})();

const discountRowObserver = new MutationObserver(() => {
  const savedCode = localStorage.getItem('activeDiscountCode');
  const couponBadge = document.querySelector('.coupan_container_btn');
  const couponText = document.querySelector('#manual-coupon-result');

  showDiscountRow();

  if (savedCode && couponBadge && couponText && !couponText.textContent.trim()) {
    couponBadge.style.display = 'flex';
    couponText.textContent = savedCode;
  }
});

discountRowObserver.observe(document.body, {
  childList: true,
  subtree: true
});


// cart code end here





// get a quote button
document.addEventListener("click", function(e) {
  const closeBtn = e.target.closest(".gaq_close_btn");
  if (!closeBtn) return;

  e.preventDefault();
  e.stopPropagation();

  const box = closeBtn.closest(".custom_sticky_Get_A_Quote_container");
  box?.classList.add("gaq_hide");
});


// for sticky button movement on mobile device


document.addEventListener('DOMContentLoaded', () => {
  if (!window.matchMedia('(max-width: 767px)').matches) return;

  const sticky = document.querySelector('.custom_sticky_Get_A_Quote_container');
  if (!sticky) return;

  const GAP = 60;
  const OFFSET = 30;
  const SIDE_GAP = 5;

  sticky.style.position = 'fixed';
  sticky.style.zIndex = '2542';
  sticky.style.right = '0';

  function updateCloseButtonPosition(isLeftSide) {
    const closeBtn = sticky.querySelector('.gaq_close_btn');
    if (!closeBtn) return;

    if (isLeftSide) {
      closeBtn.style.left = 'auto';
      closeBtn.style.right = '-8px';
    } else {
      closeBtn.style.right = 'auto';
      closeBtn.style.left = '-8px';
    }
  }

  updateCloseButtonPosition(false);

  let isDragging = false;
  let moved = false;
  let startX = 0;
  let startY = 0;
  let initialX = 0;
  let initialY = 0;
  let dragDX = 0;
  let dragDY = 0;

  sticky.addEventListener('touchstart', (e) => {
    if (e.target.closest('.gaq_close_btn')) return;

    isDragging = true;
    moved = false;
    dragDX = 0;
    dragDY = 0;

    const touch = e.touches[0];
    const rect = sticky.getBoundingClientRect();

    startX = touch.clientX;
    startY = touch.clientY;
    initialX = rect.left;
    initialY = rect.top;

    sticky.style.transition = 'none';
    sticky.style.transform = 'none';
    sticky.style.right = 'auto';
    sticky.style.bottom = 'auto';
  }, { passive: true });

  sticky.addEventListener('touchmove', (e) => {
    if (!isDragging) return;

    e.preventDefault();

    const touch = e.touches[0];

    dragDX = touch.clientX - startX;
    dragDY = touch.clientY - startY;

    if (Math.abs(dragDX) > 5 || Math.abs(dragDY) > 5) {
      moved = true;
    }

    let newX = initialX + dragDX;
    let newY = initialY + dragDY;

    const maxX = window.innerWidth - sticky.offsetWidth;
    const minY = GAP;
    const maxY = window.innerHeight - sticky.offsetHeight - GAP;

    newX = Math.max(0, Math.min(newX, maxX));
    newY = Math.max(minY, Math.min(newY, maxY));

    sticky.style.left = `${newX}px`;
    sticky.style.top = `${newY}px`;

    updateCloseButtonPosition(newX <= SIDE_GAP + 2);
  }, { passive: false });

  sticky.addEventListener('touchend', () => {
    if (!isDragging) return;

    isDragging = false;
    if (!moved) return;

    const maxX = window.innerWidth - sticky.offsetWidth;
    const minY = GAP;
    const maxY = window.innerHeight - sticky.offsetHeight - GAP;

  // const SIDE_GAP = 5;

let snapX = dragDX < 0 ? SIDE_GAP : maxX - SIDE_GAP;
    let snapY = dragDY < 0 ? minY : maxY;

    if (Math.abs(dragDY) < 12) {
      const rect = sticky.getBoundingClientRect();
      const currentMiddleY = rect.top + rect.height / 2;
      snapY = currentMiddleY < window.innerHeight / 2 ? minY : maxY;
    }

if (Math.abs(dragDX) < 15) {
  const rect = sticky.getBoundingClientRect();
  const currentMiddleX = rect.left + rect.width / 2;

  snapX =
    currentMiddleX < window.innerWidth / 2
      ? SIDE_GAP
      : maxX - SIDE_GAP;
}

    // Upper two positions move little bit bottom
    if (snapY === minY) {
      snapY = minY + OFFSET;
    }

    // Left side two positions move little bit top
    if (snapX === 0 && snapY === maxY) {
      snapY = maxY - OFFSET;
    }

    sticky.style.transition = 'left 0.25s ease, top 0.25s ease';
    sticky.style.left = `${snapX}px`;
    sticky.style.top = `${snapY}px`;
    sticky.style.right = 'auto';
    sticky.style.bottom = 'auto';
    sticky.style.transform = 'none';
updateCloseButtonPosition(snapX <= SIDE_GAP + 2);

    setTimeout(() => {
      sticky.style.transition = '';
    }, 250);
  });

  sticky.addEventListener('touchcancel', () => {
    isDragging = false;
  });
});

// for need assistance redirect to inbox

function findElementDeep(root, selector) {
  if (!root) return null;

  const direct = root.querySelector(selector);
  if (direct) return direct;

  const all = root.querySelectorAll("*");

  for (const el of all) {
    if (el.shadowRoot) {
      const found = findElementDeep(el.shadowRoot, selector);
      if (found) return found;
    }
  }

  return null;
}

function openShopifyChat() {
  const chatWidget = document.querySelector("shopify-chat");

  if (!chatWidget) {
    console.log("shopify-chat not found");
    return;
  }

  const button = findElementDeep(
    chatWidget.shadowRoot,
    'button[part="activator"][aria-label="Open chat"]'
  );

  if (button) {

    if (button.getAttribute("aria-expanded") === "false") {
      button.click();
    } else {
      console.log("Chat is already open");
    }
  } else {
    console.log("Chat activator not found");
  }
}

document.addEventListener("click", function (e) {
  if (e.target.closest(".event_based_header_strip")) {
    openShopifyChat();
  }
});

// for yotpo review reidrrect on product page

document.addEventListener("click", (e) => {
  const ratingBox = e.target.closest(".yotpo-sr-bottom-line-right-panel");

  if (!ratingBox) return;

  const reviewSection = document.querySelector(".ugc-storefront-widgets-tabs-container");

  if (!reviewSection) return;

  const offset = 300; // header height
  const targetPosition =
    reviewSection.getBoundingClientRect().top +
    window.pageYOffset -
    offset;

  window.scrollTo({
    top: targetPosition,
    behavior: "smooth"
  });

  setTimeout(() => {
    const reviewTab =
      [...document.querySelectorAll(".ugc-storefront-widgets-tabs-container__tab")]
        .find(tab => tab.textContent.trim().toLowerCase().includes("reviews")) ||
      document.querySelector(".ugc-storefront-widgets-tabs-container__tab");

    reviewTab?.click();
  }, 800);
});


// for quote button data 
document.addEventListener("click", (e) => {
  const link = e.target.closest(".inner_container_gaq");

  if (!link) return;

  e.preventDefault();

  const payload = {
    page_url: window.location.href,
    device: /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)
      ? "Mobile"
      : "Desktop"
  };

  fetch("https://script.google.com/macros/s/AKfycbxt95TgEFqsX9u-oFmNCrwWR2QQ6hWv9LGbNpHhFPLlbotCxElMLK9XP20JtSISJL8/exec", {
    method: "POST",
    mode: "no-cors",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(payload)
  });

  setTimeout(() => {
    window.location.href = link.href;
  }, 300);
});

// $(document).on(
//   "click",
//   '.btn.stripe-hover.high[data-cmd="ok"]:visible',
//   function () {
//     alert("OK button clicked");
//   }
// );


// for custom color picker
// =============================================
// CUSTOM COLOR PICKER - CUSTOM METAL LOGO SIGN
// =============================================

(function () {

  let customColorClickPending = false;


  // =============================================
  // HELPERS
  // =============================================

  function getModal() {
    return document.querySelector(
      '[data-custom-color-modal]'
    );
  }

  function getPropertyInput() {
    return document.querySelector(
      '[data-custom-color-property]'
    );
  }

  function getElements() {

    const modal = getModal();

    if (!modal) return null;

    return {
      modal: modal,

      hexArea: modal.querySelector(
        '[data-hex-area]'
      ),

      colorPicker: modal.querySelector(
        '[data-custom-color-picker]'
      ),

      hexInput: modal.querySelector(
        '[data-custom-color-hex]'
      ),

    ralCheckbox: modal.querySelector(
  '[data-ral-checkbox]'
),

ralArea: modal.querySelector(
  '[data-ral-area]'
),

ralInput: modal.querySelector(
  '[data-ral-input]'
),

pentonCheckbox: modal.querySelector(
  '[data-penton-checkbox]'
),

pentonArea: modal.querySelector(
  '[data-penton-area]'
),

pentonInput: modal.querySelector(
  '[data-penton-input]'
),

      preview: modal.querySelector(
        '[data-custom-color-preview]'
      ),

      selectedText: modal.querySelector(
        '[data-custom-color-text]'
      ),

      error: modal.querySelector(
        '[data-custom-color-error]'
      )
    };
  }
  function validHex(value) {
    return /^#[0-9A-F]{6}$/i.test(value);
  }
  function normalizeHex(value) {

    let hex = String(value || '')
      .trim()
      .toUpperCase();

    if (
      hex &&
      !hex.startsWith('#')
    ) {
      hex = '#' + hex;
    }

    return hex;
  }
  function formatRal(value) {

    let ral = String(value || '')
      .trim()
      .toUpperCase();

    if (!ral) return '';

    if (ral.startsWith('RAL ')) {
      return ral;
    }

    if (ral.startsWith('RAL')) {
      ral = ral.substring(3).trim();
    }

    return 'RAL ' + ral;
  }

  function formatPenton(value) {

  let penton = String(value || '')
    .trim()
    .toUpperCase();

  if (!penton) return '';

  if (penton.startsWith('PANTONE ')) {
    return penton;
  }

  return 'PANTONE ' + penton;
}

  function isCustomColorSelected() {

    return Array.from(
      document.querySelectorAll(
        'input[type="radio"]:checked'
      )
    ).some(function (input) {

      return String(input.value || '')
        .toLowerCase()
        .includes('custom color');

    });
  }
  // =============================================
  // OPEN / CLOSE MODAL
  // =============================================

  function openModal() {

    const modal = getModal();

    if (!modal) {
      console.error(
        'Custom Color modal not found'
      );

      return;
    }
    modal.hidden = false;

    modal.setAttribute(
      'aria-hidden',
      'false'
    );
  }


  function closeModal() {

    const modal = getModal();

    if (!modal) return;

    modal.hidden = true;

    modal.setAttribute(
      'aria-hidden',
      'true'
    );
  }

  // =============================================
  // HEX MODE
  // =============================================

  function setHexMode() {

  const el = getElements();

  if (!el) return;

  // Turn other modes off
  el.ralCheckbox.checked = false;
  el.pentonCheckbox.checked = false;

  // Enable HEX
  el.hexArea.classList.remove(
    'is-disabled'
  );

  // Hide RAL
  el.ralArea.hidden = true;
  el.ralInput.disabled = true;

  // Hide Pantone
  el.pentonArea.hidden = true;
  el.pentonInput.disabled = true;

  el.preview.classList.remove(
    'checkbox_checked'
  );

  el.colorPicker.disabled = false;
  el.hexInput.disabled = false;

  let hex = normalizeHex(
    el.hexInput.value
  );

  if (!validHex(hex)) {
    hex = '#263C6F';
  }

  el.hexInput.value = hex;
  el.colorPicker.value = hex;

  el.preview.style.backgroundColor = hex;

  el.selectedText.textContent = hex;

  if (el.error) {
    el.error.hidden = true;
  }
}
  // =============================================
  // RAL MODE
  // =============================================

 function setRalMode() {

  const el = getElements();

  if (!el) return;

  // RAL ON
  el.ralCheckbox.checked = true;

  // Pantone OFF
  el.pentonCheckbox.checked = false;
  el.pentonArea.hidden = true;
  el.pentonInput.disabled = true;

  // Fade HEX
  el.hexArea.classList.add(
    'is-disabled'
  );

  // Show RAL
  el.ralArea.hidden = false;
  el.ralInput.disabled = false;

  // Keep HEX clickable
  el.colorPicker.disabled = false;
  el.hexInput.disabled = false;

  el.preview.classList.add(
    'checkbox_checked'
  );

  el.preview.style.backgroundColor =
    'transparent';

  const ral = formatRal(
    el.ralInput.value
  );

  el.selectedText.textContent =
    ral || 'Enter RAL code';

  if (el.error) {
    el.error.hidden = true;
  }
}

function setPentonMode() {

  const el = getElements();

  if (!el) return;

  // Pantone ON
  el.pentonCheckbox.checked = true;

  // RAL OFF
  el.ralCheckbox.checked = false;
  el.ralArea.hidden = true;
  el.ralInput.disabled = true;

  // Fade HEX
  el.hexArea.classList.add(
    'is-disabled'
  );

  // Show Pantone input
  el.pentonArea.hidden = false;
  el.pentonInput.disabled = false;

  // Keep HEX clickable
  el.colorPicker.disabled = false;
  el.hexInput.disabled = false;

  el.preview.classList.add(
    'checkbox_checked'
  );

  el.preview.style.backgroundColor =
    'transparent';

  const penton = formatPenton(
    el.pentonInput.value
  );

  el.selectedText.textContent =
    penton || 'Enter Pantone code';

  if (el.error) {
    el.error.hidden = true;
  }

  // Put cursor directly inside input
  setTimeout(function () {
    el.pentonInput.focus();
  }, 50);
}


  // =============================================
  // CUSTOM COLOR SWATCH CLICK
  // =============================================

  document.addEventListener(
    'click',
    function (event) {

      const customLabel =
        event.target.closest(
          '.custom_color_label'
        );


      if (customLabel) {

        /*
          IMPORTANT:
          Do NOT preventDefault().

          Shopify still needs to select the
          Custom Color radio/variant.
        */

        /*
          If Custom Color is already selected,
          Shopify will not trigger another
          variant change. Open directly.
        */
        if (isCustomColorSelected()) {

          openModal();

          customColorClickPending = false;

          return;
        }


        /*
          Otherwise wait for Shopify to
          select/update the variant first.
        */
        customColorClickPending = true;


        /*
          Check after Shopify processes
          the label click.
        */
        setTimeout(
          function () {

            if (
              customColorClickPending &&
              isCustomColorSelected()
            ) {

              openModal();

              customColorClickPending = false;
            }

          },
          150
        );

        return;
      }


      // CLOSE
      const closeButton =
        event.target.closest(
          '[data-custom-color-close]'
        );

      if (closeButton) {
        closeModal();
      }

    }
  );


  // =============================================
  // VARIANT CHANGE
  // =============================================

  document.addEventListener(
    'change',
    function (event) {

      if (
        !event.target.matches(
          'input[type="radio"], select'
        )
      ) {
        return;
      }

      /*
        Shopify may re-render product HTML,
        so wait slightly before accessing it.
      */
      setTimeout(
        function () {

          if (isCustomColorSelected()) {

            /*
              Only open because customer
              actually clicked Custom Color.
            */
            if (customColorClickPending) {

              openModal();

              customColorClickPending = false;
            }

          } else {

            /*
              Changed away from Custom Color.
              Remove old Custom Color property.
            */
            const propertyInput =
              getPropertyInput();

            if (propertyInput) {
              propertyInput.value = '';
            }

            customColorClickPending = false;

            closeModal();
          }

        },
        150
      );

    }
  );


  // =============================================
  // RAL CHECKBOX
  // =============================================

  document.addEventListener(
    'change',
    function (event) {

      if (
        !event.target.matches(
          '[data-ral-checkbox]'
        )
      ) {
        return;
      }
      if (event.target.checked) {
        setRalMode();
      } else {
        setHexMode();
      }

    }
  );

  // =============================================
// PANTONE CHECKBOX
// =============================================

document.addEventListener(
  'change',
  function (event) {

    if (
      !event.target.matches(
        '[data-penton-checkbox]'
      )
    ) {
      return;
    }

    if (event.target.checked) {
      setPentonMode();
    } else {
      setHexMode();
    }

  }
);


  // =============================================
  // NATIVE COLOR PICKER
  // =============================================

  document.addEventListener(
    'input',
    function (event) {

      if (
        !event.target.matches(
          '[data-custom-color-picker]'
        )
      ) {
        return;
      }
      const el = getElements();
      if (!el) return;
      /*
        User touched HEX while RAL active.
        Switch automatically to HEX.
      */
      if (el.ralCheckbox.checked) {
        setHexMode();
      }
      const hex =
        event.target.value.toUpperCase();


      el.hexInput.value = hex;

      el.preview.style.backgroundColor =
        hex;

      el.selectedText.textContent = hex;

    }
  );
  // =============================================
  // HEX TEXT INPUT
  // =============================================
  document.addEventListener(
    'focusin',
    function (event) {

      if (
        !event.target.matches(
          '[data-custom-color-hex]'
        )
      ) {
        return;
      }
      const el = getElements();
      if (
  el &&
  (
    el.ralCheckbox.checked ||
    el.pentonCheckbox.checked
  )
) {
  setHexMode();
}

    }
  );
  document.addEventListener(
    'input',
    function (event) {
      if (
        !event.target.matches(
          '[data-custom-color-hex]'
        )
      ) {
        return;
      }
      const el = getElements();
      if (!el) return;
      const hex =
        normalizeHex(
          event.target.value
        );
      if (validHex(hex)) {
        el.colorPicker.value = hex;
        el.preview.style.backgroundColor =
          hex;

        el.selectedText.textContent = hex;
      }

    }
  );
  // =============================================
  // RAL INPUT
  // =============================================

  document.addEventListener(
    'input',
    function (event) {

      if (
        !event.target.matches(
          '[data-ral-input]'
        )
      ) {
        return;
      }
      const el = getElements();

      if (!el) return;

      if (!el.ralCheckbox.checked) {
        return;
      }
      const ral =
        formatRal(
          event.target.value
        );
      el.selectedText.textContent =
        ral || 'Enter RAL code';

      el.preview.style.backgroundColor =
        'transparent';

    }
  );
// =============================================
// PANTONE INPUT
// =============================================

document.addEventListener(
  'input',
  function (event) {

    if (
      !event.target.matches(
        '[data-penton-input]'
      )
    ) {
      return;
    }

    const el = getElements();

    if (!el) return;

    if (!el.pentonCheckbox.checked) {
      return;
    }

    const penton = formatPenton(
      event.target.value
    );

    el.selectedText.textContent =
      penton || 'Enter Pantone code';

    el.preview.style.backgroundColor =
      'transparent';

  }
);

  // =============================================
  // CLICK FADED HEX AREA
  // SWITCH FROM RAL -> HEX
  // =============================================

  document.addEventListener(
    'click',
    function (event) {

      const hexArea =
        event.target.closest(
          '[data-hex-area]'
        );
      if (!hexArea) return;

      const el = getElements();

      if (!el) return;
     if (
  el.ralCheckbox.checked ||
  el.pentonCheckbox.checked
) {
  setHexMode();
}

    }
  );
  // =============================================
  // CONFIRM CUSTOM COLOR
  // =============================================
  document.addEventListener(
    'click',
    function (event) {
      const confirmButton =
        event.target.closest(
          '[data-custom-color-confirm]'
        );
      if (!confirmButton) return;
      const el = getElements();
      if (!el) return;
      el.error.hidden = true;
      let finalValue = '';
    if (el.ralCheckbox.checked) {

  const ral =
    el.ralInput.value.trim();

  if (!ral) {

    el.error.textContent =
      'Please enter a RAL color code.';

    el.error.hidden = false;

    return;
  }

  finalValue =
    formatRal(ral);

}

else if (el.pentonCheckbox.checked) {

  const penton =
    el.pentonInput.value.trim();

  if (!penton) {

    el.error.textContent =
      'Please enter a Pantone color code.';

    el.error.hidden = false;

    return;
  }

  finalValue =
    formatPenton(penton);

}

else {

  const hex =
    normalizeHex(
      el.hexInput.value
    );

  if (!validHex(hex)) {

    el.error.textContent =
      'Please enter a valid HEX color, for example #263C6F.';

    el.error.hidden = false;

    return;
  }

  finalValue = hex;
}

      // =========================================
      // SAVE TO SHOPIFY LINE ITEM PROPERTY
      // =========================================

      const propertyInput =
        getPropertyInput();
      if (!propertyInput) {

        console.error(
          'Custom Color property input not found'
        );

        return;
      }
      propertyInput.value =
        finalValue;


      console.log(
        'Custom Color saved:',
        propertyInput.value
      );
      console.log(
        'Connected form:',
        propertyInput.getAttribute('form')
      );


      el.selectedText.textContent =
        finalValue;


      closeModal();

    }
  );


  // =============================================
  // ESC CLOSE
  // =============================================

  document.addEventListener(
    'keydown',
    function (event) {

      if (event.key === 'Escape') {
        closeModal();
      }

    }
  );


  // =============================================
  // INITIAL STATE
  // =============================================

  document.addEventListener(
    'DOMContentLoaded',
    function () {

      /*
        Never open automatically on load.
      */
      closeModal();


      const el = getElements();

      if (!el) return;

     el.ralInput.disabled = true;
el.pentonInput.disabled = true;

setHexMode();

    }
  );

})();

// end custom color picker code

// for custom color picker end here
// hide Brushed Silver color option 

(function () {

  function updateBrushedSilverVisibility() {

    const materialSelect = document.querySelector(
      '.pplr_select[name="properties[Material Option]"]'
    );

    if (!materialSelect) return;

    const selectedValue = materialSelect.value.trim();

    document
      .querySelectorAll('.swatch-input__label[title="Brushed Silver"]')
      .forEach(function (label) {

        label.classList.toggle(
          "hide-brushed-silver",
          selectedValue.includes("Standard Steel")
        );

      });
  }


  document.addEventListener("change", function (event) {

    if (
      event.target.matches(
        '.pplr_select[name="properties[Material Option]"]'
      )
    ) {
      updateBrushedSilverVisibility();
    }

  });


  function init() {

    updateBrushedSilverVisibility();

    const observer = new MutationObserver(function () {
      updateBrushedSilverVisibility();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

  }


  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

})();


// for custom metal logo sign product page start here

document.addEventListener('DOMContentLoaded', () => {
  const PRODUCT_HANDLE = 'custom-metal-logo-sign';

  // Change this selector if your theme uses a different product price element.
  const PRICE_SELECTORS = [
    '[data-product-price]',
    '.product__price .price-item--regular',
    '.price__regular .price-item--regular',
    '.price-item--regular'
  ];

  let productData = null;

  async function loadProductData() {
    try {
      const response = await fetch(`/products/${PRODUCT_HANDLE}.js`);
      productData = await response.json();

      updateCustomMetalPrice();
    } catch (error) {
      console.error('Metal pricing: unable to load product data', error);
    }
  }

  function getCurrentVariantId() {
    // Standard Shopify product form variant ID
    const variantInput =
      document.querySelector(
        'form[action*="/cart/add"] input[name="id"]'
      );

    if (variantInput?.value) {
      return String(variantInput.value);
    }

    // Fallback to URL variant
    const params = new URLSearchParams(window.location.search);

    return params.get('variant');
  }

  function getCurrentVariant() {
    if (!productData) return null;

    const variantId = getCurrentVariantId();

    return productData.variants.find(
      variant => String(variant.id) === String(variantId)
    );
  }

  function getMaterialValue() {
    // SELECT
    const select = document.querySelector(
      '[name="properties[Material Option]"]'
    );

    if (select && select.value) {
      return select.value.trim();
    }

    // RADIO
    const radio = document.querySelector(
      '[name="properties[Material Option]"]:checked'
    );

    if (radio) {
      return radio.value.trim();
    }
    const possibleSelects = document.querySelectorAll(
      'select, input[type="radio"]:checked'
    );

    for (const field of possibleSelects) {
      const value = field.value?.trim();

      if (
        value ===
        'Stainless Steel (SS) - Indoor/Outdoor Placement'
      ) {
        return value;
      }
    }

    return '';
  }

  function isStainlessSteelSelected() {
    return (
      getMaterialValue().toLowerCase() ===
      'stainless steel (ss) - indoor/outdoor placement'
    );
  }

  function isBrushedGoldenSelected(variant) {
    if (!variant) return false;
    return (
      String(variant.option3 || '')
        .trim()
        .toLowerCase() === 'brushed golden'
    );
  }

  function calculatePrice(variant) {
    if (!variant) return null;

    /*
     * Shopify /products/handle.js returns price
     * in cents.
     *
     * Example:
     * $160 = 16000
     */
    const basePrice = Number(variant.price);

    const brushedGolden =
      isBrushedGoldenSelected(variant);

    const stainlessSteel =
      isStainlessSteelSelected();

    let multiplier = 1;

    if (brushedGolden && stainlessSteel) {
      multiplier = 1.20;
    } else if (stainlessSteel) {
      multiplier = 1.15;
    } else if (brushedGolden) {
      multiplier = 1.05;
    }

    return Math.round(basePrice * multiplier);
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: Shopify.currency?.active || 'USD'
    }).format(cents / 100);
  }

  function updatePriceElements(price) {
    if (price === null) return;

    const formattedPrice = formatMoney(price);

    for (const selector of PRICE_SELECTORS) {
      const elements = document.querySelectorAll(selector);

      elements.forEach(element => {
        element.textContent = formattedPrice;
      });

      if (elements.length) {
        break;
      }
    }
  }

  function updateCustomMetalPrice() {
    const variant = getCurrentVariant();

    if (!variant) return;

    const finalPrice = calculatePrice(variant);

    updatePriceElements(finalPrice);
  }
  document.addEventListener('change', event => {
    const target = event.target;

    if (
      target.matches('select') ||
      target.matches('input[type="radio"]') ||
      target.matches('input[name="id"]')
    ) {
      // Give Shopify/ACO time to update selected variant ID
      setTimeout(updateCustomMetalPrice, 50);
      setTimeout(updateCustomMetalPrice, 200);
    }
  });

  /*
   * Some swatch apps update values through clicks
   * without firing normal change events immediately.
   */
  document.addEventListener('click', event => {
    const target = event.target.closest(
      '.pplr-swatch-element, label, button'
    );

    if (!target) return;

    setTimeout(updateCustomMetalPrice, 50);
    setTimeout(updateCustomMetalPrice, 200);
  });

  /*
   * Catch Shopify variant ID changes made programmatically.
   */
  const variantInput =
    document.querySelector(
      'form[action*="/cart/add"] input[name="id"]'
    );

  if (variantInput) {
    const observer = new MutationObserver(() => {
      updateCustomMetalPrice();
    });

    observer.observe(variantInput, {
      attributes: true,
      attributeFilter: ['value']
    });
  }

  loadProductData();
});

// for custom metal logo sign product page end here


document.addEventListener('DOMContentLoaded', () => {
  const PRODUCT_ID = '8828149137590';
  const PRODUCT_HANDLE = 'custom-metal-logo-sign';

  const PRICE_RULES = {
    brushedGoldPercent: 5,
    stainlessSteelPercent: 15
  };

  let productData = null;
  let productRoot = null;
  let lastVariantId = '';
  let updateToken = 0;
  let retryTimers = [];

  const variantCache = new Map();
  const pendingVariantRequests = new Map();

  const normalize = value =>
    String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');

  const currentHandle = () => {
    const match = location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  };

  function findProductRoot() {
    return (
      document.querySelector('main product-info[id^="MainProduct-"]') ||
      document.querySelector('main [id^="MainProduct-"]') ||
      document.querySelector('main product-info') ||
      document.querySelector('main .product') ||
      null
    );
  }

  function refreshProductRoot() {
    productRoot = findProductRoot();
    return productRoot;
  }

  function getVariantInput() {
    const root = refreshProductRoot();

    if (!root) return null;

    return (
      root.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      root.querySelector('input[name="id"][form]') ||
      null
    );
  }

  function getVariantId() {
    const input = getVariantInput();

    if (input?.value) {
      return String(input.value);
    }

    return new URLSearchParams(location.search).get('variant') || '';
  }

  function getSectionId() {
    const root = refreshProductRoot();

    if (!root) return '';

    return (
      root.dataset?.section ||
      String(root.id || '').replace(/^MainProduct-/, '')
    );
  }

  async function loadProduct() {
    if (currentHandle() !== PRODUCT_HANDLE) return false;

    try {
      const response = await fetch(`/products/${PRODUCT_HANDLE}.js`, {
        cache: 'no-store'
      });

      if (!response.ok) {
        throw new Error(`Product request failed: ${response.status}`);
      }

      const data = await response.json();

      if (String(data.id) !== String(PRODUCT_ID)) {
        console.warn('Metal pricing: product ID mismatch.', data.id);
        return false;
      }

      productData = data;
      return true;
    } catch (error) {
      console.error('Metal pricing: unable to load product.', error);
      return false;
    }
  }

  function isVariant(value, variantId) {
    return !!(
      value &&
      String(value.id) === String(variantId) &&
      Number.isFinite(Number(value.price))
    );
  }

  function findVariantDeep(value, variantId, depth = 0) {
    if (value == null || depth > 5) return null;

    if (Array.isArray(value)) {
      for (const item of value) {
        const found = findVariantDeep(item, variantId, depth + 1);
        if (found) return found;
      }
      return null;
    }

    if (typeof value !== 'object') return null;
    if (isVariant(value, variantId)) return value;

    for (const key of [
      'variant',
      'selectedVariant',
      'selected_variant',
      'selected_or_first_available_variant',
      'variants',
      'product'
    ]) {
      if (!(key in value)) continue;

      const found = findVariantDeep(value[key], variantId, depth + 1);
      if (found) return found;
    }

    return null;
  }

  function findVariantInJsonScripts(scope, variantId) {
    if (!scope?.querySelectorAll) return null;

    for (const script of scope.querySelectorAll('script[type="application/json"]')) {
      const text = String(script.textContent || '').trim();
      if (!text) continue;

      try {
        const found = findVariantDeep(JSON.parse(text), variantId);
        if (found) return found;
      } catch (_) {
        // Ignore unrelated JSON blocks.
      }
    }

    return null;
  }

  function findVariantLocally(variantId) {
    const root = refreshProductRoot();

    const fromDom = findVariantInJsonScripts(root, variantId);
    if (fromDom) return fromDom;

    const metaVariants = window.meta?.product?.variants;
    if (Array.isArray(metaVariants)) {
      const fromMeta = metaVariants.find(item => isVariant(item, variantId));
      if (fromMeta) return fromMeta;
    }

    return (
      productData?.variants?.find(item => isVariant(item, variantId)) ||
      null
    );
  }

  function moneyTextToCents(text) {
    let value = String(text || '')
      .replace(/[^0-9.,-]/g, '')
      .trim();

    if (!value) return null;

    const dot = value.lastIndexOf('.');
    const comma = value.lastIndexOf(',');

    if (dot > -1 && comma > -1) {
      value = dot > comma
        ? value.replace(/,/g, '')
        : value.replace(/\./g, '').replace(',', '.');
    } else if (comma > -1) {
      value = value.length - comma - 1 === 2
        ? value.replace(',', '.')
        : value.replace(/,/g, '');
    }

    const number = Number(value);
    return Number.isFinite(number) ? Math.round(number * 100) : null;
  }

  function variantFromRenderedSection(doc, variantId) {
    const fromJson = findVariantInJsonScripts(doc, variantId);
    if (fromJson) return fromJson;

    const priceBox = doc.querySelector('[id^="price-"], .price');
    if (!priceBox) return null;

    const onSale = priceBox.classList?.contains('price--on-sale');
    const sale = priceBox.querySelector('.price__sale .price-item--sale');
    const regular = priceBox.querySelector('.price__regular .price-item--regular');
    const target = (onSale ? sale : regular) || sale || regular;
    const price = moneyTextToCents(target?.textContent);

    if (!Number.isFinite(price)) return null;

    return {
      id: variantId,
      title: 'Selected variant',
      price,
      option1: null,
      option2: null,
      option3: null,
      options: []
    };
  }

  async function fetchVariant(variantId) {
    const key = String(variantId);

    if (pendingVariantRequests.has(key)) {
      return pendingVariantRequests.get(key);
    }

    const request = (async () => {
      try {
        const url = new URL(location.href);
        url.searchParams.set('variant', key);

        const sectionId = getSectionId();
        if (sectionId) {
          url.searchParams.set('section_id', sectionId);
        }

        const response = await fetch(url.toString(), {
          cache: 'no-store',
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (!response.ok) return null;

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        return variantFromRenderedSection(doc, key);
      } catch (error) {
        console.warn('Metal pricing: variant request failed.', key, error);
        return null;
      } finally {
        pendingVariantRequests.delete(key);
      }
    })();

    pendingVariantRequests.set(key, request);
    return request;
  }

  async function resolveVariant(variantId) {
    const key = String(variantId || '');

    if (!key) {
      return productData?.variants?.[0] || null;
    }

    if (variantCache.has(key)) {
      return variantCache.get(key);
    }

    const local = findVariantLocally(key);
    if (local) {
      variantCache.set(key, local);
      return local;
    }

    const remote = await fetchVariant(key);
    if (remote) {
      variantCache.set(key, remote);
      return remote;
    }

    return null;
  }

  function elementText(element) {
    if (!element) return '';

    const parts = [
      element.value,
      element.dataset?.value,
      element.dataset?.optionValue,
      element.getAttribute?.('data-value'),
      element.getAttribute?.('title'),
      element.getAttribute?.('aria-label')
    ];

    if (element.tagName === 'OPTION') {
      parts.push(element.textContent);
    }

    if (element.id) {
      try {
        const label = productRoot?.querySelector(
          `label[for="${CSS.escape(element.id)}"]`
        );
        if (label) parts.push(label.textContent, label.dataset?.value);
      } catch (_) {}
    }

    const label = element.closest?.('label');
    if (label) parts.push(label.textContent, label.dataset?.value);

    return normalize(parts.filter(Boolean).join(' '));
  }

  function selectedOptionTexts() {
    const root = refreshProductRoot();
    if (!root) return [];

    const values = [];

    root.querySelectorAll(
      'input[type="radio"]:checked, input[type="checkbox"]:checked'
    ).forEach(element => {
      const value = elementText(element);
      if (value) values.push(value);
    });

    root.querySelectorAll('select').forEach(select => {
      const option = select.options?.[select.selectedIndex];
      const value = normalize([
        select.value,
        option?.value,
        option?.textContent
      ].filter(Boolean).join(' '));

      if (value) values.push(value);
    });

    root.querySelectorAll([
      '.pplr-swatch-element.active',
      '.pplr-swatch-element.selected',
      '.pplr-swatch-element.is-selected',
      '.swatch-element.active',
      '.swatch-element.selected',
      '.swatch-element.is-selected',
      '[data-value].active',
      '[data-value].selected',
      '[data-value].is-selected',
      '[aria-checked="true"]',
      '[aria-selected="true"]'
    ].join(',')).forEach(element => {
      const value = elementText(element);
      if (value) values.push(value);
    });

    root.querySelectorAll('input[type="hidden"], input[type="text"]').forEach(field => {
      const name = normalize(
        field.name ||
        field.dataset?.name ||
        field.getAttribute('aria-label')
      );

      if (
        name.includes('color') ||
        name.includes('colour') ||
        name.includes('finish') ||
        name.includes('material') ||
        name.includes('metal') ||
        name.includes('surface')
      ) {
        const value = normalize(field.value);
        if (value) values.push(value);
      }
    });

    return [...new Set(values)];
  }

  function hasSelectedText(test) {
    return selectedOptionTexts().some(test);
  }

  function isBrushedGoldText(value) {
    const text = normalize(value);
    return text.includes('brushed gold');
  }

  function isBrushedGoldSelected(variant) {
    if (hasSelectedText(isBrushedGoldText)) {
      return true;
    }

    if (!variant) return false;

    return [
      variant.option1,
      variant.option2,
      variant.option3,
      ...(variant.options || [])
    ].some(isBrushedGoldText);
  }

  function isStainlessSteelSelected() {
    return hasSelectedText(value =>
      normalize(value).includes('stainless steel')
    );
  }

  function calculatePrice(variant) {
    const basePrice = Number(variant?.price);
    if (!Number.isFinite(basePrice)) return null;

    let percent = 0;

    if (isBrushedGoldSelected(variant)) {
      percent += PRICE_RULES.brushedGoldPercent;
    }

    if (isStainlessSteelSelected()) {
      percent += PRICE_RULES.stainlessSteelPercent;
    }

    return Math.round(basePrice * (1 + percent / 100));
  }

  function formatMoney(cents) {
    const currency = window.Shopify?.currency?.active || 'USD';

    return `${new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(cents / 100)} ${currency}`;
  }

  function updatePriceDom(cents) {
    const root = refreshProductRoot();
    if (!root || cents == null) return;

    const value = formatMoney(cents);
    const seen = new Set();

    const selectors = [
      '.price__sale .price-item--sale strong',
      '.price__sale .price-item--sale',
      '.price__regular .price-item--regular',
      '[data-product-price]',
      '.price-item--last'
    ];

    root.querySelectorAll(selectors.join(',')).forEach(element => {
      if (seen.has(element)) return;
      seen.add(element);

      if (
        element.matches('.price__sale .price-item--sale') &&
        element.querySelector('strong')
      ) {
        return;
      }

      if (element.textContent.trim() !== value) {
        element.textContent = value;
      }
    });
  }

  async function updatePrice() {
    if (!productData) return;

    const token = ++updateToken;
    const requestedVariantId = getVariantId();
    const variant = await resolveVariant(requestedVariantId);

    if (token !== updateToken) return;
    if (requestedVariantId !== getVariantId()) return;

    if (!variant) {
      console.warn(
        'Metal pricing: unable to resolve selected variant',
        requestedVariantId
      );
      return;
    }

    const finalPrice = calculatePrice(variant);
    if (finalPrice == null) return;

    updatePriceDom(finalPrice);
  }

  function scheduleUpdate() {
    retryTimers.forEach(clearTimeout);
    retryTimers = [];

    [0, 120, 400, 900].forEach(delay => {
      retryTimers.push(
        setTimeout(() => {
          updatePrice().catch(error => {
            console.error('Metal pricing update error:', error);
          });
        }, delay)
      );
    });
  }

  function isInsideProduct(target) {
    const root = refreshProductRoot();
    return !!(root && target && root.contains(target));
  }

  function handleOptionEvent(event) {
    if (!productData || !isInsideProduct(event.target)) return;

    if (event.type === 'click') {
      const control = event.target.closest(
        '.pplr-swatch-element, .swatch-element, [data-value], label, button'
      );

      if (!control || !productRoot.contains(control)) return;
    } else if (!event.target.matches('select, input')) {
      return;
    }

    scheduleUpdate();
  }

  document.addEventListener('change', handleOptionEvent, true);
  document.addEventListener('input', handleOptionEvent, true);
  document.addEventListener('click', handleOptionEvent, true);

  [
    'zepto:change',
    'pplr:change',
    'product:variant-change',
    'variant:change',
    'product:updated'
  ].forEach(eventName => {
    document.addEventListener(eventName, scheduleUpdate);
  });

  function setupMutationObserver() {
    const main = document.querySelector('main');
    if (!main) return;

    const controlSelector = [
      'product-info',
      'form[action*="/cart/add"]',
      'input',
      'select',
      '.pplr-swatch-element',
      '.swatch-element',
      '[data-value]',
      '[aria-checked]',
      '[aria-selected]'
    ].join(',');

    const observer = new MutationObserver(mutations => {
      let relevant = false;

      for (const mutation of mutations) {
        const target = mutation.target;

        // Ignore our own visible price text updates.
        if (target?.closest?.('.price, [data-product-price]')) {
          continue;
        }

        if (mutation.type === 'attributes') {
          if (target?.matches?.(controlSelector)) {
            relevant = true;
            break;
          }

          continue;
        }

        if (mutation.type === 'childList') {
          for (const node of mutation.addedNodes) {
            if (node.nodeType !== 1) continue;

            if (
              node.matches?.(controlSelector) ||
              node.querySelector?.(controlSelector)
            ) {
              relevant = true;
              break;
            }
          }

          if (relevant) break;
        }
      }

      const currentVariantId = getVariantId();

      if (currentVariantId !== lastVariantId) {
        lastVariantId = currentVariantId;
        relevant = true;
      }

      if (relevant) {
        scheduleUpdate();
      }
    });

    observer.observe(main, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'checked', 'aria-checked', 'aria-selected', 'class']
    });
  }

  async function init() {
    if (currentHandle() !== PRODUCT_HANDLE) return;

    const loaded = await loadProduct();
    if (!loaded) return;

    refreshProductRoot();
    lastVariantId = getVariantId();

    setupMutationObserver();
    scheduleUpdate();
  }

  init();
});
  

// for custom metal sign product code start here

// for custom metal sign code for tooltip

(function () {
  if (!window.matchMedia('(max-width: 520px)').matches) return;

(function () {
  const selector = '.custom_metal_product input:checked + .shape-option.rk-shapes';
  let timer;
  let activeIndex = -1;

  const style = document.createElement('style');
  style.textContent = `
    ${selector} .shape-option__tooltip {
      opacity: 1 !important;
      visibility: visible !important;
          transform: translate(-50%, 0) !important;
    }

    ${selector}.show-shape-tooltip .shape-option__tooltip {
      opacity: 1 !important;
      visibility: visible !important;
      transform: translate(-50%, 0) !important;
    }
  `;
  document.head.appendChild(style);

  function scheduleTooltip(index) {
    clearTimeout(timer);
    activeIndex = index;

    document.querySelectorAll(selector).forEach(function (shape) {
      shape.classList.remove('show-shape-tooltip');
    });

    timer = setTimeout(function () {
      // Find the current element in case the variant update replaced it.
      const shape = document.querySelectorAll(selector)[activeIndex];

      if (shape) {
        shape.classList.add('show-shape-tooltip');
      }
    }, 2000);
  }

  document.addEventListener('click', function (event) {
    const shape = event.target.closest(selector);
    if (!shape) return;

    const shapes = Array.from(document.querySelectorAll(selector));
    scheduleTooltip(shapes.indexOf(shape));
    // Existing click handlers select the variant immediately.
  }, true);

  function initialize() {
    const shapes = Array.from(document.querySelectorAll(selector));
    const selectedIndex = shapes.findIndex(function (shape) {
      return shape.matches(
        '.active, .selected, [aria-checked="true"], [aria-pressed="true"]'
      ) || shape.querySelector('input:checked');
    });

    if (shapes.length) {
      scheduleTooltip(selectedIndex >= 0 ? selectedIndex : 0);
    }
  }

  if (document.readyState === 'complete') {
    initialize();
  } else {
    window.addEventListener('load', initialize, { once: true });
  }
})();
})();

//  for custom metal sign code for tooltip code end here
 